export const urls = {
  postSaleService:
    "https://drive.google.com/file/d/1kMNjMau_N14nGI3efCue99-sWmjLwZKe/view",
  facebook: "https://www.facebook.com/damenkom",
  twitter: "https://x.com/damenkom",
  linkedin: "https://www.linkedin.com/company/damenkom",
  home: "https://damenkom.com",
  requestHelp:
    "https://damenkom.com/%d8%a7%d8%b3%d8%aa%d9%85%d8%a7%d8%b1%d8%a9-%d8%ad%d9%84-%d9%85%d8%b4%d8%a7%d9%83%d9%84-%d8%b9%d9%85%d9%84%d9%8a%d8%a7%d8%aa-%d8%a7%d9%84%d8%af%d9%81%d8%b9-%d8%a7%d9%84%d9%85%d8%b3%d8%a8%d9%82/",
};
